import { loginTemp } from '../services/api';

// localStorage에서 유효한 토큰 반환 (만료 시 null)
export const getStoredToken = () => {
  try {
    const tokenInfo = localStorage.getItem('tokenInfo');
    if (!tokenInfo) return null;
    const parsed = JSON.parse(tokenInfo);
    if (parsed.expireTime && Date.now() < parsed.expireTime) {
      return parsed.accessToken;
    }
  } catch (error) {
    console.error('Error getting stored token:', error);
  }
  return null;
};

// 저장된 UUID 반환
export const getStoredUUID = () => localStorage.getItem('lastKnownUUID');

// UUID로 토큰 발급 후 localStorage 저장
export const issueToken = async (uuid) => {
  const tokenData = await loginTemp(uuid);
  const tokenInfo = {
    accessToken: tokenData.accessToken,
    refreshToken: tokenData.refreshToken,
    expireTime: Date.now() + tokenData.accessTokenExpireIn,
  };
  localStorage.setItem('tokenInfo', JSON.stringify(tokenInfo));
  return tokenData.accessToken;
};
